import { useState, useCallback } from 'react';
import { NavLink, useNavigate } from 'react-router';
import { useAuth } from '@/contexts/AuthContext';

export function Navbar() {
  const navigate = useNavigate();
  const {
    selectedCompanyName,
    companyLogoUrl,
    isCompanyNameOnNav,
    isCompanyLogoOnNav,
    activityReportNpsdClientList,
    caseReportNpsdClientList,
    callsForServiceNpsdClientList,
    analyticsReportNpsdClientList,
    signOut,
  } = useAuth();

  const [navbarOpen, setNavbarOpen] = useState(false);

  const handleSignOut = useCallback((e: React.MouseEvent) => {
    e.preventDefault();
    signOut();
    navigate('/login', { replace: true });
  }, [signOut, navigate]);

  const handleNavClick = useCallback(() => {
    setNavbarOpen(false);
  }, []);

  return (
    <nav className="kstc-navbar">
      <div className="kstc-navbar__inner">
        <NavLink className="kstc-navbar__brand" to="/home" onClick={handleNavClick}>
          {isCompanyLogoOnNav && companyLogoUrl && (
            <img src={companyLogoUrl} height="50" loading="lazy" style={{ maxWidth: '280px' }} />
          )}
          {isCompanyLogoOnNav && companyLogoUrl && isCompanyNameOnNav && (
            <span style={{ marginLeft: '5px' }}></span>
          )}
          {isCompanyNameOnNav && <span>{selectedCompanyName}</span>}
        </NavLink>
        <button
          className="kstc-navbar__toggler"
          type="button"
          onClick={() => setNavbarOpen(!navbarOpen)}
          aria-controls="navbarNav"
          aria-expanded={navbarOpen}
          aria-label="Toggle navigation"
        >
          <i className="fas fa-bars"></i>
        </button>
        <div className={`kstc-navbar__collapse${navbarOpen ? ' kstc-navbar__collapse--open' : ''}`} id="navbarNav">
          <ul className="kstc-navbar__nav">
            <li className="kstc-navbar__item">
              <NavLink className={({ isActive }) => `kstc-navbar__link${isActive ? ' active' : ''}`} to="/home" onClick={handleNavClick}>
                Home
              </NavLink>
            </li>
            {activityReportNpsdClientList.length > 1 && (
              <li className="kstc-navbar__item">
                <NavLink className={({ isActive }) => `kstc-navbar__link${isActive ? ' active' : ''}`} to="/activity-reports" onClick={handleNavClick}>
                  Activity Reports
                </NavLink>
              </li>
            )}
            {caseReportNpsdClientList.length > 1 && (
              <li className="kstc-navbar__item">
                <NavLink className={({ isActive }) => `kstc-navbar__link${isActive ? ' active' : ''}`} to="/case-reports" onClick={handleNavClick}>
                  Case Reports
                </NavLink>
              </li>
            )}
            {callsForServiceNpsdClientList.length > 1 && (
              <li className="kstc-navbar__item">
                <NavLink className={({ isActive }) => `kstc-navbar__link${isActive ? ' active' : ''}`} to="/calls-for-service" onClick={handleNavClick}>
                  Calls For Service
                </NavLink>
              </li>
            )}
            {analyticsReportNpsdClientList.length > 0 && (
              <li className="kstc-navbar__item">
                <NavLink className={({ isActive }) => `kstc-navbar__link${isActive ? ' active' : ''}`} to="/analytics-reports" onClick={handleNavClick}>
                  Analytics Reports
                </NavLink>
              </li>
            )}
          </ul>
          <span className="kstc-navbar__end">
            <ul className="kstc-navbar__nav">
              <li>
                <a className="kstc-navbar__link" onClick={handleSignOut} href="#">Sign Out</a>
              </li>
            </ul>
          </span>
        </div>
      </div>
    </nav>
  );
}
